import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import DashboardPage from "../pages/DashboardPage";
import UserSessionPage from "../pages/UserSessionPage";
import LoginPage from "../pages/LoginPage";
import RolesListPage from "../pages/RolesListPage";
import RoleEditorPage from "../pages/RoleEditorPage";
import UsersPage from "../pages/UsersPage";
import SitesPage from "../pages/SitesPage";
import ForbiddenPage from "../pages/ForbiddenPage";
import PermissionRoute from "../auth/PermissionRoute";
import { tokenStore } from "../api/axiosClient";
import SiteDetailPage from "../pages/SiteDetailPage";
import SecurityOverviewPage from "../pages/SecurityOverviewPage";
import ThreatsPage from "../pages/ThreatsPage";
import TrafficRulesPage from "../pages/TrafficRulesPage";
import ProtectionSettingsPage from "../pages/ProtectionSettingsPage";
import AnalyticsPage from "../pages/AnalyticsPage";
import AlertsPage from "../pages/AlertsPage";
import ModulesHubPage from "../pages/ModulesHubPage";
import InsightPage from "../pages/InsightPage";
import NotificationsPage from "../pages/NotificationsPage";
import IncidentsPage from "../pages/IncidentsPage";
import ReportsPage from "../pages/ReportsPage";
import MyDashboardsPage from "../pages/MyDashboardsPage";
import AdSensePage from "../pages/AdSensePage";
import GoalsPage from "../pages/GoalsPage";
import WorkPage from "../pages/WorkPage";
import AccountPage from "../pages/AccountPage";
import AdminPage from "../pages/AdminPage";
import AuditLogPage from "../pages/AuditLogPage";
import DiagnosticsPage from "../pages/DiagnosticsPage";
const Protected = ({ children }) => {
    if (!tokenStore.getAccessToken()) {
        return <Navigate to="/login" replace />;
    }
    return children;
};

export default function AppRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/forbidden" element={<ForbiddenPage />} />

                <Route
                    path="/"
                    element={
                        <Protected>
                            <DashboardPage />
                        </Protected>
                    }
                />
                <Route
                    path="/sessions"
                    element={
                        <Protected>
                            <UserSessionPage />
                        </Protected>
                    }
                />

                {/* Security Center (Batch 1) */}
                <Route
                    path="/security"
                    element={
                        <PermissionRoute code="ivt.read">
                            <SecurityOverviewPage />
                        </PermissionRoute>
                    }
                />
                <Route
                    path="/security/threats"
                    element={
                        <PermissionRoute code="ivt.read">
                            <ThreatsPage />
                        </PermissionRoute>
                    }
                />
                <Route
                    path="/security/rules"
                    element={
                        <PermissionRoute code="rules.read">
                            <TrafficRulesPage />
                        </PermissionRoute>
                    }
                />
                <Route
                    path="/security/settings"
                    element={
                        <PermissionRoute code="protection.read">
                            <ProtectionSettingsPage />
                        </PermissionRoute>
                    }
                />
                <Route
                    path="/security/alerts"
                    element={
                        <PermissionRoute code="alerts.read">
                            <AlertsPage />
                        </PermissionRoute>
                    }
                />
                <Route
                    path="/analytics"
                    element={
                        <PermissionRoute code="analytics.read">
                            <AnalyticsPage />
                        </PermissionRoute>
                    }
                />

                {/* 100-module suite */}
                <Route path="/modules" element={<PermissionRoute code="ivt.read"><ModulesHubPage /></PermissionRoute>} />
                <Route path="/insights/:key" element={<PermissionRoute code="ivt.read"><InsightPage /></PermissionRoute>} />
                <Route path="/notifications" element={<PermissionRoute code="workspace.read"><NotificationsPage /></PermissionRoute>} />
                <Route path="/incidents" element={<PermissionRoute code="workspace.read"><IncidentsPage /></PermissionRoute>} />
                <Route path="/reports" element={<PermissionRoute code="workspace.read"><ReportsPage /></PermissionRoute>} />
                <Route path="/my-dashboards" element={<PermissionRoute code="workspace.read"><MyDashboardsPage /></PermissionRoute>} />
                <Route path="/adsense" element={<PermissionRoute code="workspace.read"><AdSensePage /></PermissionRoute>} />
                <Route path="/goals" element={<PermissionRoute code="workspace.read"><GoalsPage /></PermissionRoute>} />
                <Route path="/work" element={<PermissionRoute code="workspace.read"><WorkPage /></PermissionRoute>} />
                <Route path="/account" element={<PermissionRoute code="workspace.read"><AccountPage /></PermissionRoute>} />
                <Route path="/admin" element={<PermissionRoute code="admin.manage"><AdminPage /></PermissionRoute>} />
                <Route path="/admin/audit" element={<PermissionRoute code="audit.read"><AuditLogPage /></PermissionRoute>} />
                <Route path="/admin/diagnostics" element={<PermissionRoute code="ivt.read"><DiagnosticsPage /></PermissionRoute>} />

                {/* RBAC admin */}
                <Route
                    path="/roles"
                    element={
                        <PermissionRoute code="roles.read">
                            <RolesListPage />
                        </PermissionRoute>
                    }
                />
                <Route
                    path="/roles/new"
                    element={
                        <PermissionRoute code="roles.create">
                            <RoleEditorPage />
                        </PermissionRoute>
                    }
                />
                <Route
                    path="/roles/:id"
                    element={
                        <PermissionRoute code="roles.read">
                            <RoleEditorPage />
                        </PermissionRoute>
                    }
                />
                <Route
                    path="/users"
                    element={
                        <PermissionRoute code="users.read">
                            <UsersPage />
                        </PermissionRoute>
                    }
                />

                {/* Sites (Module 04) */}
                <Route
                    path="/sites"
                    element={
                        <PermissionRoute code="sites.read">
                            <SitesPage />
                        </PermissionRoute>
                    }
                />
                {/* /sites/:id route will be added in Step 7c when SiteDetailPage exists */}

                <Route
                    path="*"
                    element={<Navigate to={tokenStore.getAccessToken() ? "/" : "/login"} replace />}
                />
                <Route
    path="/sites/:id"
    element={
        <PermissionRoute code="sites.read">
            <SiteDetailPage />
        </PermissionRoute>
    }
/>
            </Routes>
        </BrowserRouter>
    );
}